import CustomLink from "./CustomLink";
import Image from "./Image";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ProjectList.module.css";

export function ProjectItem({ projectPage }) {
  return (
    <li className={styles.ProjectItem}>
      <CustomLink href={projectPage.url} className={styles.CustomLink}>
        <div className={styles.image}></div>
        {projectPage.gridImage && (
          <Image
            className={styles.image}
            src={projectPage.gridImage.src}
            srcSet={projectPage.gridImage.srcSet}
            sizes="100vw"
            alt={`${projectPage.title} project image`}
            width={800}
            height={450}
          ></Image>
        )}
        <div className={styles.details}>
          <h3 className={styles.title}>{projectPage.title}</h3>
          <p className={styles.shortDescription}>
            {projectPage.shortDescription}
          </p>
        </div>
      </CustomLink>
    </li>
  );
}

export default function ProjectList({
  className = "",
  projectPages,
  imageBackgroundColor,
}) {
  const classes = classNames(styles.ProjectList, className);
  return (
    <ul className={classes}>
      {projectPages.map((projectPage, index) => {
        return (
          <ProjectItem
            key={index}
            projectPage={projectPage}
            imageBackgroundColor={imageBackgroundColor}
          />
        );
      })}
    </ul>
  );
}

ProjectList.propTypes = {
  className: PropTypes.string,
  imageBackgroundColor: PropTypes.string.isRequired,
  projectPages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      shortDescription: PropTypes.string.isRequired,
      gridImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
      }),
    }),
  ).isRequired,
};
